module.exports = __webpack_public_path__ + "static/media/shape_portal1.f635f8aa.svg";